<script>
	import Conference from '../../States/Conference';
	export let conference = {};

	function getActiveColor(state) {
		return state ? 'danger' : 'primary';
	}

	function getHoldText(state) {
		return state ? 'Unhold' : 'Hold';
	}

	function getMuteText(state) {
		return state ? 'Unmute' : 'Mute';
	}

	function getMuteIcon(state) {
		return state ? 'uil-volume-up' : 'uil-volume-off';
	}

	function getHoldIcon(state) {
		return state ? 'uil-play' : 'uil-pause';
	}

	function setDisabled(status, hangupButton = false) {
		let disabled = status != 'participant-join';
		if(hangupButton && status == 'ringing')
			disabled = false;
		return disabled;
	}

	function setRinging(status) {
		return status == 'ringing' ? 'ringing' : '';
	}

	function setLeft(status) {
		return status == 'participant-leave' ? 'left' : '';
	}

	async function mute(participantSid, mute) {
		await Conference.muteParticipant(participantSid, mute);
	}

	async function hold(participantSid, hold) {
		await Conference.holdParticipant(participantSid, hold);
	}

	async function hangup(participantSid, agentId = false) {
		await Conference.hangupParticipant(participantSid, agentId);
	}

</script>

<style>
	.round-name {
		position: relative;
		float: left;
		margin-right: 1.1em;
	}

	.inbox-item {
		display: grid;
		align-items: center;
		grid-template-columns: 16% auto;
	}

	.call-icon-group button {
		padding: .2em;
		font-size: 1.6em;
	}

	.left {
		opacity: .5;
	}

	.participant-type-header {
		border-bottom: 1px solid #e1e1e1;
	}

	.participant-type-header p {
		margin-bottom: 0.4em;
    	font-weight: bold;
	}
</style>


<div class="card">
	<div class="card-body">
		<h4 class="header-title mb-3">Participants</h4>
		<div class="inbox-widget">
			<div class="participant-type-header">
				<p>Agents</p>
			</div>
			{#each conference.participants as participant}
				{#if participant.agentId}
					<div class="inbox-item">
						<div class="round-name {setRinging(participant.status)} {setLeft(participant.status)}">{participant.initials}</div>
						<p class="inbox-item-author">{participant.name} {#if participant.status == 'participant-leave'} <span class="badge bg-secondary">Left</span>{/if} {#if participant.status == 'ringing'} <span class="badge bg-info">Calling</span>{/if}</p>
						{#if participant.status != 'participant-left' && conference.active}
							<div class="inbox-item-date call-icon-group">
								<button class="btn btn-sm btn-link text-primary"  data-bs-toggle="tooltip" data-bs-placement="top" title="{getHoldText(participant.hold)}" data-bs-original-title="{getHoldText(participant.hold)}" disabled="{setDisabled(participant.status) || participant.agentId}" on:click={() => hold(participant.sid, !participant.hold)}><i class="{getHoldIcon(participant.hold)}"></i> </button>
								<!-- <button class="btn btn-sm btn-link text-primary" data-bs-toggle="tooltip" data-bs-placement="top" title="{getMuteText(participant.muted)}" data-bs-original-title="{getMuteText(participant.muted)}" disabled="{setDisabled(participant.status) || participant.agentId}" on:click={() => mute(participant.sid, !participant.muted)}><i class="{getMuteIcon(participant.muted)}"></i> </button> -->
								<button class="btn btn-sm btn-link text-danger" data-bs-toggle="tooltip" data-bs-placement="top" title="Hangup participant" disabled="{setDisabled(participant.status, true)}" on:click={() => hangup(participant.sid, participant.agentId)}><i class="uil-phone-slash"></i> </button>
							</div>
						{/if}
					</div>
				{/if}
			{/each}
			<div class="participant-type-header">
				<p>Contacts</p>
			</div>
			{#each conference.participants as participant}
				{#if participant.contactId}
					<div class="inbox-item">
						<div class="round-name {setRinging(participant.status)} {setLeft(participant.status)}">{participant.initials}</div>
						<p class="inbox-item-author">{participant.name} {#if participant.status == 'participant-leave'} <span class="badge bg-secondary">Left</span>{/if} {#if participant.status == 'ringing'} <span class="badge bg-info">Calling</span>{/if}</p>
						{#if participant.status != 'participant-left' && conference.active}
							<div class="inbox-item-date call-icon-group">
								<button class="btn btn-sm btn-link text-primary"  data-bs-toggle="tooltip" data-bs-placement="top" title="{getHoldText(participant.hold)}" data-bs-original-title="{getHoldText(participant.hold)}" disabled="{setDisabled(participant.status) || participant.agentId}" on:click={() => hold(participant.sid, !participant.hold)}><i class="{getHoldIcon(participant.hold)}"></i> </button>
								<!-- <button class="btn btn-sm btn-link text-primary" data-bs-toggle="tooltip" data-bs-placement="top" title="{getMuteText(participant.muted)}" data-bs-original-title="{getMuteText(participant.muted)}" disabled="{setDisabled(participant.status) || participant.agentId}" on:click={() => mute(participant.sid, !participant.muted)}><i class="{getMuteIcon(participant.muted)}"></i> </button> -->
								<button class="btn btn-sm btn-link text-danger" data-bs-toggle="tooltip" data-bs-placement="top" title="Hangup participant" disabled="{setDisabled(participant.status, true)}" on:click={() => hangup(participant.sid)}><i class="uil-phone-slash"></i> </button>
							</div>
						{/if}
					</div>
				{/if}
			{/each}
		</div>
	</div>
</div>